import styles from './Row.module.css';

interface RowProps {
    keyValue: string;
    value: string;
}

export const Row: React.FC<RowProps> = ({ keyValue, value }) => {
    return <div className={styles.detailRow}>
        <strong>{keyValue}:</strong> <span>{value}</span>
    </div>
};